import { render, staticRenderFns } from "./ModulesViewPanel.vue?vue&type=template&id=33c11127&scoped=true&"
import script from "./ModulesViewPanel.vue?vue&type=script&lang=js&"
export * from "./ModulesViewPanel.vue?vue&type=script&lang=js&"
import style0 from "./ModulesViewPanel.vue?vue&type=style&index=0&id=33c11127&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c11127",
  null
  
)

export default component.exports